import type { MetricTabEntry } from 'model/types/data-analytics';

export function isMetricTabVisible(tab: MetricTabEntry, flags: string[] | undefined): boolean {
  return !tab.flag || (flags?.includes(tab.flag) ?? false);
}
